var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#DBEBFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 20.75V43.25",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 37C17.0761 37 18.3479 36.4732 19.2855 35.5355C20.2232 34.5979 20.75 33.3261 20.75 32C20.75 30.6739 20.2232 29.4021 19.2855 28.4645C18.3479 27.5268 17.0761 27 15.75 27V22C15.75 21.6685 15.8817 21.3505 16.1161 21.1161C16.3505 20.8817 16.6685 20.75 17 20.75H47C47.3315 20.75 47.6495 20.8817 47.8839 21.1161C48.1183 21.3505 48.25 21.6685 48.25 22V27C46.9239 27 45.6521 27.5268 44.7145 28.4645C43.7768 29.4021 43.25 30.6739 43.25 32C43.25 33.3261 43.7768 34.5979 44.7145 35.5355C45.6521 36.4732 46.9239 37 48.25 37V42C48.25 42.3315 48.1183 42.6495 47.8839 42.8839C47.6495 43.1183 47.3315 43.25 47 43.25H17C16.6685 43.25 16.3505 43.1183 16.1161 42.8839C15.8817 42.6495 15.75 42.3315 15.75 42V37Z",
    stroke: "#0256B8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.9adeb43dad8a11b79e5df8030d9b8588.svg";
export { ForwardRef as ReactComponent };